module.exports = __webpack_public_path__ + "static/media/Location - Pin.421484f6.svg";